var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsers2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15859 11.0502C9.05859 11.0402 8.93859 11.0402 8.82859 11.0502C6.44859 10.9702 4.55859 9.02018 4.55859 6.62018C4.55859 4.17018 6.53859 2.18018 8.99859 2.18018C11.4486 2.18018 13.4386 4.17018 13.4386 6.62018C13.4286 9.02018 11.5386 10.9702 9.15859 11.0502Z",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4112 4.18018C18.3512 4.18018 19.9112 5.75018 19.9112 7.68018C19.9112 9.57018 18.4113 11.1102 16.5413 11.1802C16.4613 11.1702 16.3713 11.1702 16.2812 11.1802",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15875 14.7402C1.73875 16.3602 1.73875 19.0002 4.15875 20.6102C6.90875 22.4502 11.4188 22.4502 14.1688 20.6102C16.5888 18.9902 16.5888 16.3502 14.1688 14.7402C11.4288 12.9102 6.91875 12.9102 4.15875 14.7402Z",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3398 20.1802C19.0598 20.0302 19.7398 19.7402 20.2998 19.3102C21.8598 18.1402 21.8598 16.2102 20.2998 15.0402C19.7498 14.6202 19.0798 14.3402 18.3698 14.1802",
    stroke: "#C4D26E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers2);
export default __webpack_public_path__ + "static/media/users2.91a8d4ea25cf6260df9fe847035c7c51.svg";
export { ForwardRef as ReactComponent };